import React from 'react';
import { Cancel } from '@finect/tabular-icons/cancel';
import { PlusCircle } from '@finect/tabular-icons/plusCircle';
import { ChipBlock, ActionIcon } from './partials';
export var Chip = function Chip(_ref) {
  var value = _ref.value,
    onAction = _ref.onAction,
    isActive = _ref.isActive,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? true : _ref$withIcon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  return React.createElement(ChipBlock, {
    size: size,
    isActive: isActive,
    onClick: onAction
  }, React.createElement("span", null, value, isActive), withIcon ? React.createElement(ActionIcon, null, isActive ? React.createElement(Cancel, {
    size: "18"
  }) : React.createElement(PlusCircle, {
    size: "18"
  })) : null);
};